<app-navigation></app-navigation>
  <!-- Footer -->
  <footer>
      ＠fomachanyade/tobimap 2020
  </footer>
<router-outlet></router-outlet>

